import { useDialogState, useDialogDispatch } from "./DialogContext";

export const useDialog = () => {
  const dispatch = useDialogDispatch();

  const { activeDialog, dialogProps } = useDialogState();

  const openDialog = (dialog: string, props?: any) => {
    dispatch({ type: "dialog/open", payload: { dialog, props } });
  };

  const closeDialog = (dialog: string) => {
    dispatch({ type: "dialog/close", payload: { dialog } });
  };

  return { activeDialog, openDialog, closeDialog, dialogProps };
};
